define(
  'starFilterHandler',[
    'builderShowcaseObserver',
    'event'
  ],
  (builderShowcaseObserver) => {
    'use strict';

    function StarFilterHandler() {
    }

    function StarFilterInitHandler() {
    }

    /**
    * @private
    * onFilterStarChanged: manage the change on the filters by stars.
    *
    */
    function onFilterStarChanged(data) {
      data.preventDefault();
      let starFilter = Number(data.currentTarget.dataset.rate);
      const updatedSearchParams = {
        ReviewStar: starFilter
      };
      starFilter = starFilter !== 0 ? starFilter : null;
      builderShowcaseObserver.setParameters(updatedSearchParams);
      builderShowcaseObserver.commit();
      const state = builderShowcaseObserver.getState();
      state.data.ReviewSearchParams.ReviewStar = starFilter;
      state.filterType = 'starFilter';
      const pageUrl = document.querySelector('[data-page-number="1"]').href;
      window.history.pushState({}, null, pageUrl);
      builderShowcaseObserver.OnStarFilterChanged(state);
    }

    /**
    * @private
    * SetListenersStarsSort: set the listeners related to the stars filter.
    *
    */
    function SetListenersStarsSort() {
      const starFilterList = document.querySelectorAll('[data-component="filter-by-star"]');
      starFilterList.forEach((el) => { el.addEventListener('click', onFilterStarChanged); });
    }

    const events = {
      onSortByChanged: {
        callbacks: [onFilterStarChanged],
        elements: '[data-component="filter-by-star"]',
        events: ['change'],
      },
    };

    /**
    * @public
    * update: function for receiving notifications about state changes
    * @param {object} data information that was changed.
    *
    */
    StarFilterHandler.update = function updateStarSortValue(data) {
      onFilterStarChanged(data);
    };

    /**
    * @public
    * update: function for receiving notifications about state changes
    * @param {object} data information that was changed.
    *
    */
    StarFilterInitHandler.update = function SetListeners() {
      SetListenersStarsSort();
    };

    SetListenersStarsSort();
    window.NewHomeSource.Event(events);
    builderShowcaseObserver.subscribe('onReviewsSectionLoaded', StarFilterInitHandler);
  }

);

